<template>
  <div class="sign-in">
    <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100.1px" class="demo-ruleForm">
      <div class="booth-logo"><img src="../assets/images/logo-blue.png" /></div>
      <el-form-item label="Account" prop="userName">
        <el-input v-model.number="form.userName"></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="pass">
        <el-input type="password" v-model="form.pass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" @click="submitForm('form')">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import md5 from 'js-md5'
import axios from 'axios'
export default {
  data () {
    return {
      userName: '',
      passsword: '',
      loading: false,
      form: {
        pass: '',
        userName: ''
      },
      rules: {
        pass: [
          { required: true, message: 'Please input password', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: 'Please input account', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
  },
  methods: {
    submitForm (formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          axios.post(`${window.config.fcDomain}/api/signin`, {
            username: this.form.userName,
            password: md5(this.form.pass)
          }).then((res) => {
            this.loading = false
            const data = res.data.data
            data.tokenExpiredAt = new Date(data.tokenExpiredAt)
            localStorage.setItem('token', data.token)
            localStorage.setItem('tokenExpiredAt', data.tokenExpiredAt.getTime())
            this.$store.commit('ACCOUNT_RESTORE', data)
            this.$store.commit('USER_RESTORE', data.user)
            this.$router.push('/work/')
          })
            .catch(function (error) {
              that.loading = false
              if (error.response) {
                console.log(error.response)
                if (error.response.status === 401) {
                  that.$notify({
                    title: 'Incorrect account or password',
                    type: 'warning'
                  })
                } else if (error.response.status === 404) {
                  that.$notify({
                    title: 'Account does not exist.',
                    type: 'warning'
                  })
                }
              }
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style>
.booth-logo {
  width: 100%;
  text-align: center;
  padding: 0px 0 20px;
}
.booth-logo img {
  width: 150px;
}
.sign-in {
  width: 400px;
  margin: 0 auto;
  position: relative;
  top: 80px;
  padding: 50px 50px 50px;
  box-shadow: 0 16px 28px 0 rgba(0, 0, 0, 0.22), 0 25px 55px 0 rgba(0, 0, 0, 0.21);
  border: 1px solid #DFDFDF;
}
.sign-in .el-button {
  width: 100%
}
</style>
